"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireDefault(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _lodash = _interopRequireDefault(require("lodash.omit")),
    _lodash2 = _interopRequireDefault(require("lodash.isequal")),
    _AutoComplete = _interopRequireDefault(require("./AutoComplete")),
    _buildInputProps = _interopRequireDefault(require("../utils/buildInputProps")),
    _InputContainer = _interopRequireDefault(require("./InputContainer")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _components = require("../../../common/components");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var CLEAR_EVENT = {
  target: {
    value: ""
  }
},
    getTooltipId = function getTooltipId(a) {
  return "".concat(a, "-tooltip");
},
    Input = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.getInputProps = (0, _memoizeOne["default"])(function (a, b, c) {
      var e = c.prefix,
          f = c.styleType,
          g = c.small,
          h = (0, _buildInputProps["default"])({
        valid: b,
        calculatedSuffixIcon: a,
        allProps: c,
        onChange: d.onChange,
        onFocus: d.onFocus,
        onBlur: d.onBlur,
        styleType: f,
        small: g
      });
      return {
        hasPrefix: !!e,
        hasSuffix: !!a,
        inputProps: h
      };
    }, _lodash2["default"]), d.onChange = function (a) {
      var b = a.target.value,
          c = d.props.onChange;
      d.setState({
        value: b
      }, function () {
        "function" == typeof c && c({
          target: {
            value: b
          }
        });
      });
    }, d.onBlur = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return b = d.props.onBlur, a.next = 3, d.handleValidate();

            case 3:
              c = a.sent, d.setState({
                valid: c
              }), b && b();

            case 6:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.onFocus = function () {
      var a = d.props.onFocus;
      d.setState({
        valid: !0
      }), a && a();
    }, d.setInputRef = (0, _memoizeOne["default"])(function (a) {
      d.inputRef = a;
    }), d.focusInput = function () {
      d.inputRef && d.inputRef.focus && d.inputRef.focus();
    }, d.clearValue = function () {
      d.onChange(CLEAR_EVENT);
    }, d.buildSuffixIcon = function () {
      var a = d.props,
          b = a.suffixIcon,
          c = a.clearButton,
          e = d.state,
          f = e.valid,
          g = e.value;
      return c && g ? "object" === (0, _typeof2["default"])(c) ? _react["default"].cloneElement(c, {
        onClick: d.clearValue
      }) : _react["default"].createElement(_Icon["default"], {
        name: "close",
        size: 20,
        onClick: d.clearValue
      }) : f ? b : "alert";
    }, a.value && console.warn("Input manages it's own 'value' in local state for performance. Pass defaultValue if you want to set the starting value. **Ignoring prop**"), d.state = {
      valid: !0,
      value: a.defaultValue || ""
    }, d.inputRef = _react["default"].createRef(), d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "getInputElementFromProps",
    value: function getInputElementFromProps(a, b) {
      var c = b.hasPrefix,
          d = b.hasSuffix,
          e = this.props,
          f = e.allSuggestions,
          g = e.renderSuggestion,
          h = e.multiline;
      return f ? _react["default"].createElement(_AutoComplete["default"], {
        inputProps: a,
        allSuggestions: f,
        renderSuggestion: g,
        hasPrefix: c,
        hasSuffix: d
      }) : h ? _react["default"].createElement("textarea", (0, _extends2["default"])({
        rows: "1"
      }, a, {
        ref: this.setInputRef
      })) : _react["default"].createElement("input", (0, _extends2["default"])({}, a, {
        ref: this.setInputRef
      }));
    }
  }, {
    key: "handleValidate",
    value: function handleValidate() {
      var a = this.props.validate,
          b = this.state.value;
      return !a || a(b);
    }
  }, {
    key: "renderInput",
    value: function renderInput(a) {
      var b = a.calculatedSuffixIcon,
          c = this.state,
          d = c.value,
          e = c.valid,
          f = this.getInputProps(b, e, (0, _lodash["default"])(this.props, "value")),
          g = f.hasPrefix,
          h = f.hasSuffix,
          i = f.inputProps,
          j = _objectSpread({}, i, {
        value: d
      });

      return this.getInputElementFromProps(j, {
        hasPrefix: g,
        hasSuffix: h
      });
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.label,
          c = a.id,
          d = a.prefix,
          e = a.errorMessage,
          f = a.className,
          g = this.state.valid,
          h = this.buildSuffixIcon(),
          i = f ? (0, _defineProperty2["default"])({}, f, !b) : void 0,
          j = getTooltipId(c);
      return _react["default"].createElement(_components.LabelWrapper, {
        id: j,
        className: (0, _classnames["default"])("input-label", f),
        label: b
      }, _react["default"].createElement(_InputContainer["default"], {
        className: (0, _classnames["default"])(i),
        prefix: d,
        suffixIcon: h,
        valid: g,
        errorMessage: e,
        id: j,
        focusInput: this.focusInput
      }, this.renderInput({
        calculatedSuffixIcon: h
      })));
    }
  }]), b;
}(_react["default"].Component);

exports["default"] = Input, Input.defaultProps = {
  className: void 0,
  disabled: !1,
  label: void 0,
  prefix: void 0,
  suffixIcon: void 0,
  errorMessage: void 0,
  clearButton: void 0,
  styleType: "PRIMARY"
};